import React from 'react'

export default function PostReview() {
    return (
        <div>
            <h1>Post</h1>
        </div>
    )
}
